// extracted by mini-css-extract-plugin
module.exports = {"pageNavigationMenu":"CombinedMenu_pageNavigationMenu__sw0Cj","mobileOnly":"CombinedMenu_mobileOnly__XhAuX"};